var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.83333C5 1.82081 5.82081 1 6.83333 1H14.8089C15.4273 1 16.0041 1.31182 16.3428 1.82929L22.7006 11.5426C22.896 11.841 23 12.19 23 12.5467V21.1667C23 22.1792 22.1792 23 21.1667 23H6.83333C5.82081 23 5 22.1792 5 21.1667V2.83333Z",
    fill: "#002C65"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 18,
    height: 9,
    rx: 1,
    fill: "#48A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4292 15.2261H4.16113V14.4263H5.4292C5.62516 14.4263 5.78467 14.3944 5.90771 14.3306C6.03076 14.2645 6.12077 14.1733 6.17773 14.0571C6.2347 13.9409 6.26318 13.8099 6.26318 13.6641C6.26318 13.516 6.2347 13.3781 6.17773 13.2505C6.12077 13.1229 6.03076 13.0203 5.90771 12.9429C5.78467 12.8654 5.62516 12.8267 5.4292 12.8267H4.5166V17H3.49121V12.0234H5.4292C5.81885 12.0234 6.15267 12.0941 6.43066 12.2354C6.71094 12.3743 6.92513 12.5669 7.07324 12.813C7.22135 13.0591 7.29541 13.3405 7.29541 13.6572C7.29541 13.9785 7.22135 14.2565 7.07324 14.4912C6.92513 14.7259 6.71094 14.9071 6.43066 15.0347C6.15267 15.1623 5.81885 15.2261 5.4292 15.2261ZM9.53076 17H8.44727L8.4541 16.2002H9.53076C9.79964 16.2002 10.0264 16.1398 10.2109 16.019C10.3955 15.896 10.5345 15.7171 10.6279 15.4824C10.7236 15.2477 10.7715 14.964 10.7715 14.6313V14.3887C10.7715 14.1335 10.7441 13.909 10.6895 13.7153C10.637 13.5216 10.5584 13.3587 10.4536 13.2266C10.3488 13.0944 10.2201 12.9953 10.0674 12.9292C9.91471 12.8608 9.73926 12.8267 9.54102 12.8267H8.42676V12.0234H9.54102C9.8737 12.0234 10.1779 12.0804 10.4536 12.1943C10.7316 12.306 10.972 12.4666 11.1748 12.6763C11.3776 12.8859 11.5337 13.1366 11.6431 13.4282C11.7547 13.7176 11.8105 14.04 11.8105 14.3955V14.6313C11.8105 14.9845 11.7547 15.307 11.6431 15.5986C11.5337 15.8903 11.3776 16.141 11.1748 16.3506C10.9743 16.5579 10.7339 16.7186 10.4536 16.8325C10.1756 16.9442 9.868 17 9.53076 17ZM9.02832 12.0234V17H8.00293V12.0234H9.02832ZM13.5811 12.0234V17H12.5557V12.0234H13.5811ZM15.5635 14.1494V14.9492H13.3008V14.1494H15.5635ZM15.8027 12.0234V12.8267H13.3008V12.0234H15.8027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b0d30b7c08f210ddc8d8dfaad9545c8d.svg";
export { ForwardRef as ReactComponent };